import * as React from "react";
const SvgFiRrQuiz = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-quiz_svg__a)">
      <path
        fill="#062147"
        d="M21.999 22.941a1 1 0 0 1-.94 1.057L21 24c-.525 0-.966-.41-.998-.941a3 3 0 0 0-1.942-2.634l-5.404-2.026a1 1 0 0 1-.649-.937v-5.354c0-.538-.362-1.018-.825-1.093a.99.99 0 0 0-.823.224 1 1 0 0 0-.353.762v8.455a1.56 1.56 0 0 1-.888 1.414 1.56 1.56 0 0 1-1.66-.185l-1.712-1.363c-.012-.009-.016-.023-.027-.032s-.023-.011-.033-.02a1.001 1.001 0 0 0-1.364 1.464l.568.548c.648.624.206 1.72-.694 1.72a1 1 0 0 1-.694-.28l-.558-.538a2.994 2.994 0 0 1 4.025-4.435q.01.006.021.011l1.015.808v-7.564c0-.881.385-1.714 1.056-2.285a3.02 3.02 0 0 1 2.44-.675c1.428.232 2.504 1.552 2.504 3.067v4.661l4.755 1.783a5 5 0 0 1 3.236 4.39zM5.16 3.416c-.018-.036-.103-.083-.16-.083-.055 0-.145.055-.167.102l-.725 2.121h1.784zM0 5a5 5 0 1 1 10.001.001A5 5 0 0 1 0 5m2.959 2.778a.55.55 0 0 0 .515-.368l.254-.743h2.544l.254.743a.544.544 0 0 0 1.029-.349L6.193 3.006c-.286-.647-.685-.784-1.194-.784s-.909.137-1.202.804L2.443 7.06a.544.544 0 0 0 .515.717zm13.485-1.111h1.643c.29 0 .549-.211.577-.499a.557.557 0 0 0-.553-.612h-2.222v.556c0 .307.248.556.555.556zm1.664-2.834c-.029-.288-.288-.499-.578-.499h-1.086a.556.556 0 0 0-.556.556v.556h1.667a.557.557 0 0 0 .553-.612zM12 5a5 5 0 1 1 10.001.001A5 5 0 0 1 12 5m2.778 1c0 .982.796 1.778 1.778 1.778h1.512c.876 0 1.635-.657 1.705-1.53a1.67 1.67 0 0 0-.765-1.541c.144-.254.223-.549.214-.863-.024-.911-.801-1.622-1.713-1.622h-.848c-1.088 0-1.883.796-1.883 1.778z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-quiz_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQuiz;
